<template>
    <form method="get">
        <button class="btn btn-dark" type="button" data-toggle="collapse" data-target="#filter" aria-expanded="false" aria-controls="collapseExample" v-if="width <= 768">
            Filter
        </button>
        <div :class="{ 'show': width > 768, 'collapse': width <= 768 }" id="filter" v-cloak>
            <div class="card-body">
                <div class="form-group">
                    <label for="sortby">Sort By</label>
                    <select class="form-control" name="sortby" id="sortby" v-model="currentSort">
                        <option value="views_desc">Most Popular</option>
                        <option value="price_asc">Price Low to High</option>
                        <option value="price_desc">Price High to Low</option>
                        <option value="name_asc">Name A-Z</option>
                        <option value="name_desc">Name Z-A</option>
                    </select>
                </div>

                <div class="form-group" v-for="(options, filterName) in filters">
                    <filter-checkbox-group
                            :filter-name="filterName"
                            :options="options"
                            :active="activeFilters[filterName]"
                    ></filter-checkbox-group>
                </div>

                <div class="form-group">
                    <button type="submit" class="btn btn-dark filter">Filter</button>
                </div>

            </div>

        </div>
    </form>
</template>

<script>

    import FilterCheckboxGroup from './FilterCheckboxGroup.vue';

    export default {

        components: { FilterCheckboxGroup },

        props: ['category', 'filters', 'sortBy', 'activeFilters'],

        data() {
            return {
                width: window.screen.availWidth,
                currentSort: null,
                currentActiveFilters: [],
            }
        },

        created() {
            window.addEventListener('resize', this.setWidth)
            this.setWidth();
            this.currentSort = this.sortBy;
            this.currentActiveFilters = this.activeFilters;
        },
        mounted() {
            const { category } = this;
            const regex = new RegExp(/^.*\//);
            const baseUrl = regex.exec(window.location.href);
            const ccCategory = {
                id: category.id,
                name: category.name,
                url: `${baseUrl}${category.url}`,
            };
            window.ccLayer = window.ccLayer || [];
            ccLayer.push({
                ccEvent: 'categoryViewed',
                src: 'custom',
                ...ccCategory,
            });
        },
        destroyed() {
            window.removeEventListener('resize', this.setWidth)
        },
        methods: {
            setWidth() {
                this.width = window.screen.availWidth;
            },
        },
    }
</script>
